import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarVerticalPosition, MatSnackBarHorizontalPosition } from '@angular/material/snack-bar';
import { ErrorSnackbarComponent } from '@shared/modules/snackbar-template/components/error-snackbar/error-snackbar.component';
import { ServiceError } from '../models/dtos/response.dto';
import { UniversalSnackbarComponent } from '../modules/snackbar-template/components/universal-snackbar/universal-snackbar.component';
import { BehaviorSubject, take, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly _duration = 5000;
  private readonly _vPosition: MatSnackBarVerticalPosition = 'top';
  private readonly _hPosition: MatSnackBarHorizontalPosition = 'end';

  private _actionClicked$ = new BehaviorSubject<boolean>(false);
  public actionClicked$ = this._actionClicked$.asObservable();

  constructor(private readonly _matSnackBar: MatSnackBar) {}

  ok(message: string): void {
    this._matSnackBar.open(message, undefined, {
      duration: this._duration,
      verticalPosition: this._vPosition,
      horizontalPosition: this._hPosition,
      panelClass: ['mat-snackbar-panel-ok'],
    });
  }

  error(errors: ServiceError[]): void {
    this._matSnackBar.openFromComponent(ErrorSnackbarComponent, {
      data: errors,
      duration: this._duration,
      verticalPosition: this._vPosition,
      horizontalPosition: this._hPosition,
      panelClass: ['mat-snackbar-panel-error'],
    });
  }

  errorMessage(message: string): void {
    this._matSnackBar.open(message, 'close', {
      duration: this._duration,
      verticalPosition: this._vPosition,
      horizontalPosition: this._hPosition,
      panelClass: ['mat-snackbar-panel-error'],
    });
  }

  openSnackBar(
    message: string,
    duration?: number,
    _vPosition?: MatSnackBarVerticalPosition,
    _hPosition?: MatSnackBarHorizontalPosition,
    icon?: string,
    panelClass?: string[],
    isSVG = true
  ) {
    const _icon = icon ? icon : '';
    this._matSnackBar.openFromComponent(UniversalSnackbarComponent, {
      duration: duration || this._duration,
      horizontalPosition: _hPosition || 'right',
      verticalPosition: _vPosition || 'top',
      panelClass: panelClass || ['mat-snackbar-panel-ok'],
      data: { message, icon: _icon, isSVG, panelClass },
    });
  }

  // eslint-disable-next-line max-params
  openSnackBarGeneric(
    message: string,
    duration?: number,
    _vPosition?: MatSnackBarVerticalPosition,
    _hPosition?: MatSnackBarHorizontalPosition,
    icon?: string,
    panelClass?: string[],
    isSVG = true,
    description?: string,
    hasAction = false,
    textAction?: string,
    hasLongButton = false,
    textLongButton?: string,
    hasCopyButton = false
  ) {
    const _icon = icon ? icon : '';
    this._matSnackBar.openFromComponent(UniversalSnackbarComponent, {
      duration: duration || this._duration,
      horizontalPosition: _hPosition || 'right',
      verticalPosition: _vPosition || 'top',
      panelClass: panelClass || ['mat-snackbar-panel-ok'],
      data: {
        message,
        icon: _icon,
        isSVG,
        panelClass,
        description,
        hasAction,
        textAction,
        hasLongButton,
        textLongButton,
        hasCopyButton,
      },
    });
  }

  onClickAction(value: boolean) {
    this._actionClicked$.next(value);
  }

  //#region Multiple Snackbar Playground

  //FIXME DO NOT DELETE
  // msgs: string[] = [];

  // public push(message: string): void {
  //   this.msgs.push(message);
  //   this.showSnackBar();
  // }

  // showSnackBar() {
  //   let snackTimer = timer(0, 8000).pipe(take(this.msgs.length));

  //   let sub = snackTimer.subscribe(i => {
  //     this.openSnackBar2(this.msgs[i]);
  //     if (i === this.msgs[i].length) {
  //       sub.unsubscribe();
  //     }
  //   });
  // }

  // openSnackBar2(message: string) {
  //   this._matSnackBar.open(message, '', {
  //     duration: 5000,
  //   });
  // }

  //#endregion
}
